import ReactIcon from "./project-icons/frontend/reactjs-icon.png";
import AngularIcon from "./project-icons/frontend/angular-icon.png";
import NextIcon from "./project-icons/frontend/nextjs-icon.png";
import SvelteIcon from "./project-icons/frontend/svelte-icon.png";
import NodeIcon from "./project-icons/frontend/nodejs-icon.png";
import VueIcon from "./project-icons/frontend/vuejs-icon.png";
import TypescriptIcon from "./project-icons/frontend/typescript-icon.png";
import FirebaseIcon from "./project-icons/backend/firebase-icon.png";
import ReduxIcon from "./project-icons/backend/redux-icon.png";
import SanityIcon from "./project-icons/backend/sanity-icon.png";
import StripeIcon from "./project-icons/backend/stripe-logo.png";
import Web3Icon from "./project-icons/backend/web-3-icon.png";
import ApiIcon from "./project-icons/backend/api-icon.png";
import GraphQLIcon from "./project-icons/backend/graphql-icon.png";
import PostgreSQLIcon from "./project-icons/backend/postgresql-icon.png";
import MongoIcon from "./project-icons/backend/mongodb-icon.png";
import PostmanIcon from "./project-icons/backend/postman-icon.png";
import NestIcon from "./project-icons/backend/nest-icon.png";
import PrismaIcon from "./project-icons/backend/prismadb.png";

import MaterialIcon from "./project-icons/design/material-ui.png";
import StyledIcon from "./project-icons/design/styled-components.png";
import TailwindIcon from "./project-icons/design/tailwind-css-icon.png";
import CSSIcon from "./project-icons/design/css-icon.png";
import SassIcon from "./project-icons/design/sass-icon.png";
import FramerMotion from "./project-icons/design/framermotion.jpeg";

import TourImage from "./project-images/tour-image.png";
import ClipzImage from "./project-images/clip.png";
import EcommerceImage from "./project-images/crown-basic.png";
import BlogImage from "./project-images/blog-firebase.JPG";
import StripeImage from "./project-images/stripe.png";
import CarouselImage from "./project-images/carousel.png";
import SvelteImage from "./project-images/svelte.png";
import MonstersImage from "./project-images/monsters.png";
import CartImage from "./project-images/cartreducer.png";
import CoffeeImage from "./project-images/nextjscoffe.JPG";
import MediumImage from "./project-images/medium.png";
import ComfyImage from "./project-images/comfy.png";
import OpenseaImage from "./project-images/opensea.png";
import FormikImage from "./project-images/formik.png";
import GymImage from "./project-images/gym.png";
import MaterialImage from "./project-images/miui.png";
import InstagramImage from "./project-images/insta.JPG";
import AngularFormImage from "./project-images/angularform.png";
import AngularApiImage from "./project-images/angular-api.png";
import YoutubeImage from "./project-images/youtube-image.png";
import RickMorty from "./project-images/rickmorty.png";
import GraphCMS from "./project-images/graphcms.png";
import Notflix from "./project-images/notflix.JPG";
import NodeReactGraphql from "./project-images/gql-node-react.JPG";
import AngularFakeStore from "./project-images/angular-fakestore.png";
import VueMusic from "./project-images/vuemusic.JPG";
import NestPostgresImage from "./project-images/postgresql-1.JPG";
import QrImagePayment from "./project-images/qrcode-payment.png";
import PortfolioImage from "./project-images/sampletour.JPG";
import VueMealsImage from "./project-images/vue-meals.JPG";
import TwitterNextjsImage from "./project-images/twitternextjs.JPG";
import DashboardImage from "./project-images/dashboard.JPG";
import AdvancedDashboardImage from "./project-images/advanced-dashboard.JPG";
import BlogAngularImage from "./project-images/angular-blog.JPG";
import AdminBlogAngularImage from "./project-images/admin-angular-blog.JPG";
import VividlyImage from "./project-images/vividly.JPG";
import LodgemeImage from "./project-images/lodgeme.JPG";
import ImaginifyImage from "./project-images/imaginify.JPG";

export const projectDatas = [
  {
    id: 41,
    title: "Imaginify AI",
    framework: "Next js",
    cardIcon: NextIcon,
    icons: [NextIcon, TailwindIcon, PrismaIcon, MongoIcon],
    deployedLink: "https://ai-saas-next14.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/ai-saas-next14",
    image: ImaginifyImage,
    detail:
      "This Saas project is implemented for changing background ,object recolor and generating fills and restore image using Next js 14/Tailwind css and Clerk for user authentication. User details are saved in mongodb with collections of users,payments and subscription payment is handled using Stripe webhooks. Initially this application has limited number of credits like 5-6 for generating new images and once you exceed your credit you need to pay amount and can make your edits unlimitedly in the application. The API from cloudinary such as  googleimageapi are used to generate images",
  },
  {
    id: 39,
    title: "Vividly SAAS",
    framework: "React js/CSS",
    cardIcon: ReactIcon,
    icons: [ReactIcon, CSSIcon, FramerMotion],
    deployedLink: "https://vividly-new.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/vividly-new",
    image: VividlyImage,
    detail:
      "This project is implemented for a startup company named Vividly which focusses on image editing and subscriptions, subscriptions are to be implemented later, now a trial part for uploading and cropping images are done using npm packages",
  },
  {
    id: 40,
    title: "Lodgeme",
    framework: "React js/Node js",
    cardIcon: ReactIcon,
    icons: [ReactIcon, NodeIcon, CSSIcon, MongoIcon],
    deployedLink: "https://lodgme-client.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/lodgme-client",
    image: LodgemeImage,
    detail:
      "This is a demo version which has dummmy content posts. This project is implemented for a company in Paris Lodgeme which is a travel agency helps you to find and search houses, lodges, apartments, and hotels. This project covers registering of user, signing of user , user verification with email and mobile authentications, booking dates verification(from and to date), booking of your apartment , billing details and payment with stripe and order history. The backend is mplemented with Node js and MongoDB and it is depyed in Render as it runs on free tier. You will be having booked house in the orders page and chat support with crisp.",
  },
  {
    id: 1,
    title: "Clipz Website",
    framework: "Angular js/Typescript/Firebase",
    cardIcon: AngularIcon,
    icons: [AngularIcon, TypescriptIcon, FirebaseIcon, TailwindIcon],
    deployedLink: "https://angular-video-website-upload.vercel.app",
    gitLink:
      "https://github.com/Adithyavarun-creator/Angular-Video-websiteUpload",
    image: ClipzImage,
    detail:
      "This project is implemented to watch and uplaod videos using Angular js as frontend and Firebase as backend, in backend we save the user credentials with uid and the video that has been uploaded by him/her. ffmpeg is used to click the screenshots of first 3 seconds of video for having the picture in video card. The storage part handles saving the video clip uploaded by user, and basic CRUD operations are implemented using the firebase. NGRX is used for some parts in project to handle multiple map and multiple saving functions",
  },
  {
    id: 38,
    title: "BlogPost Frontend",
    framework: "Angular js",
    cardIcon: AngularIcon,
    icons: [AngularIcon, TypescriptIcon, TailwindIcon, FirebaseIcon],
    deployedLink: "https://blog-angular-js.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/blog-angular-js",
    image: BlogAngularImage,
    detail:
      "Angular 14 is one of the most powerful frontend tool which is a great framework as it combines declarative templates, dependency injection, end-to-end tooling, and integrated best practices to solve development challenges which has typescript integration. In this project, the blog and its category contents are fetched from firebase storage and each of the blogs are divided as Featured Blog and All Blogs. The blogs can also be categorized into some UI topics that are mentioned below the header part such as Tailwind,Vue , so once you click on specific topic the blogs generate according to the chosen topic. The users can also subscribe the blog post for every new updates as well",
  },
  {
    id: 37,
    title: "BlogPost Admin",
    framework: "Angular js",
    cardIcon: AngularIcon,
    icons: [AngularIcon, TypescriptIcon, TailwindIcon, FirebaseIcon],
    deployedLink: "https://blog-angular-js.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/admin-blog-angular-js",
    image: AdminBlogAngularImage,
    detail:
      "This is the admin dashboard part where the admin can manage the create,read,update and delete posts,categories and subscribers. This admin page is implemented in a separate angular app in order to avoid any merging errors while deploying the frontend app and because of unique styles of routing system in Angular applications. The post forms are implemented using Reactive Form Module which has some advanced features like touch,invalid and dirty validation techniques inbuilt than any other js framework feature such as React or Next. So an admin can custom his subscribed users,cateogries and posts as he edits and it gets loaded as needed in frontend application",
  },

  {
    id: 36,
    title: "Advanced Dashboard",
    framework: "React js",
    cardIcon: ReactIcon,
    icons: [ReactIcon, TailwindIcon, MaterialIcon],
    deployedLink: "https://dashboard-react-coral.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/Advance-Dashboard-React",
    image: AdvancedDashboardImage,
    detail:
      "A web built dashboard created using React js with light mode and dark mode for accessing only for the admin to show all the status of managing team, contact information and invoice updates.The invoices can be downloaded even as pdf formats as well. The datas are generated using mockdata API. The statistics are shown using 4 charts such as pie, bar, line and geography charts with mockdata api. The generation of these charts , calendars are done using packages @fullcalendar and @nivo for react high quality 3D views. And for table generation as a standard package Material UI's data-grid was used to show the admin and user roles. You can also view a geographical chart to see the statistics that has encountered over all the world",
  },
  {
    id: 35,
    title: "Dashboard with Table Contents",
    framework: "React js",
    cardIcon: ReactIcon,
    icons: [ReactIcon, SassIcon, MaterialIcon],
    deployedLink: "https://dashboard-react-tables.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/dashboard-react-tables",
    image: DashboardImage,
    detail:
      "A simple user friendly dashboard built with React js with light mode and dark mode to show how the users and charts are been merged with datas. The line chart is implemented with react-line-charts package to have a decent and peculiar view and have crisp of average in each months. The products and users are worked on through with Material UI. This has routing to products and users page where admin can add product and users with images",
  },

  {
    id: 34,
    title: "Twitter with Nextjs",
    framework: "Next js - 13",
    cardIcon: NextIcon,
    icons: [NextIcon, TypescriptIcon, TailwindIcon, PrismaIcon, MongoIcon],
    deployedLink: "https://twitter-prisma-mongo-db.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/Twitter-Prisma-MongoDB",
    image: TwitterNextjsImage,
    detail:
      "This project is performed with Next js version 13 which is the latest build for rendering server side components. I have used Prisma to generate models that can be saved in MongoDB database for backend accordingly defined by the models with Posts and User Sessions in Prisma. In this I have implemented register and login using NextAuth built by Next js. The functionalities that work are uploading a image, posting a tweet, updating a tweet, liking a tweet, commenting a tweet, checking out user's profile and his timeline ",
  },
  {
    id: 28,
    title: "Music (Listen & Upload)",
    framework: "Vue js",
    cardIcon: VueIcon,
    icons: [VueIcon, TailwindIcon, FirebaseIcon],
    deployedLink: "https://vue-music-application-ivory.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/Vue-Music-Application",
    image: VueMusic,
    detail:
      "This project is performed with Vue js where you can upload your favorite music, listen multiple songs and edit your song information. As Vue js is one of the hard hitting frontend framework it is implemented with Pinia for state management and Firebase as backend for authentication and data(song collection and user collection) storage purpose. Music playing is been implemented with Howler js package to select specific song. Translation of language with English and French is done using i18n which is a custom internatioalization that supports simple translation, localization such as pluralization, number, datetime. Each user when logged in gets accessed to his list of uploaded songs to manage page(route page) the song list and to handle Create, Read and Upadate and Delete operation to customize their views.",
  },
  {
    id: 33,
    title: "Meals with API",
    framework: "Vue js",
    cardIcon: VueIcon,
    icons: [VueIcon, TailwindIcon, ApiIcon],
    deployedLink: "https://vuex-with-api.vercel.app/by-letter/A",
    gitLink: "https://github.com/Adithyavarun-creator/Vuex-with-API",
    image: VueMealsImage,
    detail:
      "This project is performed with Vue js framework to fetch the list of meals from demo meals API. The meals are categorised by clicking on each letters and using search params to find specific meal and ingredients. For each meal a unique route is created to have suggestion of how much ingredients is added and its youtube link preparation is also targeted for the preparation",
  },
  {
    id: 27,
    title: "Notflix",
    framework: "React js",
    cardIcon: ReactIcon,
    icons: [ReactIcon, StyledIcon, ApiIcon],
    deployedLink: "https://sendsteps.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/sendsteps-notflix",
    image: Notflix,
    detail:
      "This project is performed to view list of movies which is fetched from TMDB API service, the movies are fetched and generated in the homepage. A search box is given to search your needed movies and each movie is rendered with its movie detailed page and designs are implemented with Styled components",
  },
  {
    id: 32,
    title: "Scan and Pay",
    framework: "React js",
    cardIcon: ReactIcon,
    icons: [ReactIcon, StripeIcon, FirebaseIcon],
    gitLink: "https://github.com/Adithyavarun-creator/netlify-4gl",
    deployedLink: "https://superb-nasturtium-5b7e56.netlify.app",
    image: QrImagePayment,
    detail:
      "This project is implemented for a company in Seville(Spain) for the purpose of automated payments for using washing machines in a dorm, by scanning the qr code the user is generated to a webpage to enter his details and the washing machine used and selects the amount to pay in euros. After that the user can enter his card details and complete his payment. Once the payment is initiated when money is received, a dialog box delivers a success message and if there is an error in payment, the dialog box displays a error message. After getting a success message, a the user can download the generated invoice for the payment initiated with the payment details and washing box number. Additionally translation of multiple languages are alos added using i18next package for translation of website.",
  },

  {
    id: 29,
    title: "Nest PostgreSQL",
    framework: "Nest js",
    cardIcon: NestIcon,
    icons: [NestIcon, TypescriptIcon, PostgreSQLIcon, PostmanIcon],
    gitLink: "https://github.com/Adithyavarun-creator/nest-postgresql-typeorm",
    image: NestPostgresImage,
    detail:
      "Nest js is a perfect Node.js framework for building efficient, reliable and scalable server-side applications. This Nest js is integrated with Postgreql databse to store the models and schemas that are implemented using Nest js.TypeORM is a TypeScript ORM (object-relational mapper) library that makes it easy to link TypeScript application up to a relational database database. Book Model and User Model is created and saved with the database. All major CRUD operations are handled and datas are saved in the Postgresql database with relations to Userid and Book details.",
  },
  {
    id: 30,
    title: "Nest backend JWT",
    framework: "Nest js",
    cardIcon: NestIcon,
    icons: [NestIcon, TypescriptIcon, PostmanIcon],
    gitLink: "https://github.com/Adithyavarun-creator/nestjs-jwt-auth",
    image: NestIcon,
    detail:
      "Nest js is a perfect Node.js framework for building efficient, reliable and scalable server-side applications. The application deals with verification when a user is signed in , we produce a secret key using JWT to make the user secure and authenticated. So whenever a user logs in a secret key is provided and with that secret key a user can be able to do his CRUD operations to manage a particular upload in database. And only specific users can post or update a change in database as Authentication is also enabled using AuthGuard and User Role Guards with Nest js.",
  },
  {
    id: 22,
    title: "Youtube",
    framework: "React js/Material UI",
    cardIcon: ReactIcon,
    icons: [ReactIcon, MaterialIcon],
    deployedLink: "https://react-youtube-clone-ogxq.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/react-youtube-clone",
    image: YoutubeImage,
    detail:
      "This project is implemented using the rapid API service to fetch the list of video datas according to the trendings listed and searchbar is also implemented to find specific videos to watch and corresponding channel page is also implemented using this framework. Each and every videos are loaded with the title of video,channel names and suggested videos",
  },
  {
    id: 23,
    title: "Rick Morty API",
    framework: "React js/GraphQL",
    cardIcon: GraphQLIcon,
    icons: [ReactIcon, GraphQLIcon, StyledIcon],
    deployedLink: "https://react-graphql-api.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/react-graphql-api",
    image: RickMorty,
    detail:
      "This project is to demonstrate the use GraphQL with React using graphql API https://rickandmortyapi.com/graphql to fetch the queries and its params that gives you list of episodes and title , fetching these details from playground we use it in the frontend using grapqhql hooks such as useQuery and useLazyQuery",
  },
  {
    id: 31,
    title: "Nest MongoDB",
    framework: "Nest js",
    cardIcon: NestIcon,
    icons: [NestIcon, TypescriptIcon, MongoIcon, PostmanIcon],
    gitLink: "https://github.com/Adithyavarun-creator/nest-mongodb-api ",
    image: NestIcon,
    detail:
      "Nest js is a perfect Node.js framework for building efficient, reliable and scalable server-side applications. The application deals with implementing a restaurant with basic CRUD operations using MongoDB. For uploading a restaurant user role is been authenticated so that only admin can add a restaurant and not a common user can add a restaurant. With this restaurant, relevant meal is also added , so that each restaurants has a unique meal items which can also be handled by admin with CRUD operations.",
  },
  {
    id: 24,
    title: "Blog Article",
    framework: "Next js/GraphQL",
    cardIcon: GraphQLIcon,
    icons: [NextIcon, GraphQLIcon],
    deployedLink: "https://graphql-nextjs-blog-henna.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/GraphQl-Nextjs-Blog",
    image: GraphCMS,
    detail:
      "This project is about fetching the blogpost from the Hygraphql which is a custom graphql backend where you can define own schemas ,models and slugs for creating the blogs, the frontend part helps to fetch the blogs and each of the detailed blog page that is done using Next js with GraphQL",
  },
  {
    id: 25,
    title: "ECommerce App",
    framework: "Angular js",
    cardIcon: AngularIcon,
    icons: [AngularIcon, TypescriptIcon, StripeIcon, MaterialIcon],
    deployedLink: "https://angular-ecommerce-fakeapi.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/Angular-ECommerce-store",
    image: AngularFakeStore,
    detail:
      "This project is implemented using fake data API to fetch the product detail and its categories to show in the homepage. Most of the functionalities are used using rxjs parameters to follow the active subscriptions of the cart and total amount. The backend is connected with Node server where the functionality of payment operation is handled for stripe",
  },
  {
    id: 26,
    title: "Node React",
    framework: "GraphQL",
    cardIcon: GraphQLIcon,
    icons: [ReactIcon, NodeIcon, GraphQLIcon],
    gitLink: "https://github.com/Adithyavarun-creator/GraphQL-node-react",
    image: NodeReactGraphql,
    detail:
      "This project is performed to create queries and mutations with node as backend and accessing it in react as frontend , the backend has list of dummy user datas for querying and mutations to perform creating,updating and deleting in apollo server. The frontend fetches data from the Apollo server and they are been designed with buttons and forms using React js",
  },
  // {
  //   id: 2,
  //   title: "API Fetching",
  //   framework: "Angular js",
  //   cardIcon: AngularIcon,
  //   icons: [AngularIcon, ApiIcon],
  //   deployedLink: "https://angular-api-tasks-j6ar.vercel.app",
  //   gitLink: "https://github.com/Adithyavarun-creator/Angular-api-tasks",
  //   image: AngularApiImage,
  //   detail:
  //     "API is used as static backend to render the contents that are saved in json-server, through Angular services are used to perform the CRUD operations to render the datas from json-server and displayed in frontend",
  // },
  {
    id: 3,
    title: "Ecommerce store with redux",
    framework: "React js/Redux/Firebase",
    cardIcon: ReactIcon,
    icons: [ReactIcon, ReduxIcon, FirebaseIcon, StripeIcon],
    deployedLink: "https://clothing-store-with-redux-2t6w.vercel.app",
    gitLink:
      "https://github.com/Adithyavarun-creator/Clothing-store-with-redux",
    image: EcommerceImage,
    detail:
      "This project demonstrates an e-commerce cart connected with react,firebase, and redux framework which is helpful to find out the actions that takes place when performing a an operation such as state management or is function dispatch. Using redux helps you to point out the exact flow of project working and its architecture",
  },
  {
    id: 4,
    title: "Ecommerce Clothing",
    framework: "React js/Firebase",
    cardIcon: ReactIcon,
    icons: [ReactIcon, StripeIcon, FirebaseIcon],
    deployedLink: "https://clothing-store-with-redux-2t6w.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/clothing-try-two",
    image: EcommerceImage,
    detail:
      "This project demonstrates an e-commerce cart connected with react,firebase, and stripe payment system.When user purchases a product his payment status is checked and confirmed with stripe and the purchas history details are saved in firebase",
  },
  {
    id: 5,
    title: "Coffee Store",
    framework: "Next js",
    cardIcon: NextIcon,
    icons: [NextIcon, ApiIcon],
    deployedLink:
      "https://nextjs-coffee-store-setup-gws6qehu2-adithyavarun-creator.vercel.app",
    gitLink:
      "https://github.com/Adithyavarun-creator/nextjs-coffee-store-setup",
    image: CoffeeImage,
    detail:
      "This project helps a user to find a coffee shop anywhere from his location, hooks are used for detecting the current location and fetching datas according to the location and the results are transformed to user as response. This function even forwards a default shop picture if the coffee shop does not have a profile picture in its location. By clicking on each coffee shops the reviews and ratings are rendered and even the user can give his vote to the each coffee shop that he/she likes",
  },
  {
    id: 6,
    title: "Instagram Clone",
    framework: "Next js",
    cardIcon: NextIcon,
    icons: [NextIcon],
    deployedLink: "https://nextjs-instagram-clone-lth7.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/Nextjs-Instagram-clone",
    image: InstagramImage,
    detail:
      "Clone of Instagram frontend part to show how flexboxes are widely used over here for design purpose",
  },
  {
    id: 7,
    title: "Blog Application",
    framework: "Svelte js",
    cardIcon: SvelteIcon,
    icons: [SvelteIcon],
    deployedLink: "https://svelte-crud-operations-z6tq.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/Svelte-CRUD-operations",
    image: SvelteImage,
    detail:
      "As Svelte is used for simple frontend applications, this project is implemented to handle with basic add and delete functionalities. In this blog user can mark his rating and upload his content and push it, so that other users can view it",
  },
  {
    id: 8,
    title: "Blog with Firebase",
    framework: "React js/Firebase",
    cardIcon: ReactIcon,
    icons: [ReactIcon, FirebaseIcon],
    deployedLink: "https://blog-firebase-yhff.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/blog-firebase",
    image: BlogImage,
    detail:
      "Blogs are often used for content interaction purpose, so in this project it is implemented with react and firebase a blog can be created  with uplaoding image and generating url for the uploaded image, with login and register functions.When a user logs in he can view the list of blogs and can render the single blog page from the blog list",
  },
  {
    id: 9,
    title: "Monsters Card",
    framework: "React js",
    cardIcon: ReactIcon,
    icons: [ReactIcon],
    deployedLink: "https://monsters-rolodex-hnkz.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/monsters-rolodex",
    image: MonstersImage,
    detail:
      "Monster images are some game faces used by China, so with this API, each monster's names and search of each monsters are performed",
  },
  {
    id: 10,
    title: "React Gym",
    framework: "React js",
    cardIcon: ReactIcon,
    icons: [ReactIcon],
    deployedLink: "https://react-gym-frontend-kwwg.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/react-gym-frontend",
    image: GymImage,
    detail:
      "A frontend gym website which has some animations and count packages for showing the calories burnt, and exercise details are been showed in this project. With text cards, photos and using membership pricing the styles play a major part in this website",
  },
  {
    id: 11,
    title: "Form validation",
    framework: "Angular js",
    cardIcon: AngularIcon,
    icons: [AngularIcon, FirebaseIcon],
    deployedLink:
      "https://angular-form-validation-c2co-miynmch1n-adithyavarun-creator.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/angular-form-validation",
    image: AngularFormImage,
    detail:
      "Forms are commonly used in every websites , this project is implemented using form builder and form controller which is used in Angular 13 for having validations and error checkings in the form",
  },
  {
    id: 33,
    title: "Grid and Flex",
    framework: "React js",
    cardIcon: ReactIcon,
    icons: [ReactIcon, CSSIcon],
    deployedLink: "https://paragon-react-design.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/paragon-react-design",
    image: PortfolioImage,
    detail:
      "This is a website implemented to show how the flexboxes and grids works according to the pages and its options",
  },
  {
    id: 12,
    title: "API Fetching",
    framework: "Angular js",
    cardIcon: AngularIcon,
    icons: [AngularIcon, ApiIcon],
    deployedLink: "https://angular-api-tasks-j6ar.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/Angular-api-tasks",
    image: AngularApiImage,
    detail:
      "API is used as static backend to render the contents that are saved in json-server, through Angular services are used to perform the CRUD operations to render the datas from json-server and displayed in frontend",
  },

  {
    id: 13,
    title: "Stripe Website",
    framework: "React js",
    cardIcon: ReactIcon,
    icons: [ReactIcon],
    deployedLink: "https://demo-stripe-homepage-jkee.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/demo-stripe-homepage",
    image: StripeImage,
    detail:
      "Its a design of stripe homepage which has a lot of unique color gradients and transparent fonts",
  },
  {
    id: 14,
    title: "React Carousel",
    framework: "React js",
    cardIcon: ReactIcon,
    icons: [ReactIcon],
    deployedLink: "https://react-carousel-5npl.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/React-Carousel",
    image: CarouselImage,
    detail:
      "This carousel using React js, is aan efficiently smooth scrolling on that has smooth transitions with 8-10 images scrolling. Most of the websites do use it for attractions for showing multiple offers and multiple schemes, which can be often seen e-commerce/insurance/supermarket websites",
  },
  {
    id: 15,
    title: "Tour View Website",
    framework: "React js",
    cardIcon: ReactIcon,
    icons: [ReactIcon],
    deployedLink: "https://merry-kelpie-f4d6f1.netlify.app",
    gitLink: "https://github.com/Adithyavarun-creator/tour-view",
    image: TourImage,
    detail:
      "This project has list of countries that are listed with Tourist place, location and its price which is implemented useing React js with basic javascript operations such as map,filter and slice for data contents fetched from the json file",
  },

  {
    id: 16,
    title: "Cart App",
    framework: "React js",
    cardIcon: ReactIcon,
    icons: [ReactIcon],
    deployedLink: "https://cart-with-use-reducer-nxjj.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/cart-with-useReducer",
    image: CartImage,
    detail:
      "A simple cart application that encounters the total amount and total quantity, which is often used in e-commerce applications",
  },

  {
    id: 17,
    title: "Medium Blog",
    framework: "Next js/Sanity",
    cardIcon: NextIcon,
    icons: [NextIcon, TypescriptIcon, SanityIcon],
    deployedLink: "https://next-js-blog-with-sanity-cms.vercel.app",
    gitLink:
      "https://github.com/Adithyavarun-creator/Next-js-blog-with-SanityCMS",
    image: MediumImage,
    detail:
      "Medium is one of the top rated blog for discussing all kind of activities, in this blog we post content in sanity which acts as backend and it is rendered as frontend using Next js. SAnity follows GROQ codes for fetching the datas from the database which is a kind of similar to GraphQL language",
  },
  {
    id: 18,
    title: "Comfy Store",
    framework: "React js",
    cardIcon: ReactIcon,
    icons: [ReactIcon, StripeIcon],
    deployedLink: "https://comfystoreperfect.netlify.app",
    gitLink:
      "https://github.com/Adithyavarun-creator/comfy-online-store-react-hooks",
    image: ComfyImage,
    detail:
      "A store that consists list of furnitures with color variants. Each users while purchasing are accessed with OAuth authentication and when purchase is been processed the amount issaved in stripe for payment vericiation status",
  },
  {
    id: 19,
    title: "Opensea Blockchain",
    framework: "Next js",
    cardIcon: NextIcon,
    icons: [NextIcon, Web3Icon],
    deployedLink: "https://opensea-blockchain-green.vercel.app",
    gitLink:
      "https://github.com/Adithyavarun-creator/comfy-online-store-react-hooks",
    image: OpenseaImage,
    detail:
      "Future is going to be with metamask wallet for bitcoin transactions. Opensea is blockchain webpage where users can connect their metamask wallet to the website to access and this website is just an example of connecting user's wallet to the webpage",
  },
  {
    id: 20,
    title: "React Formik",
    framework: "React js",
    cardIcon: ReactIcon,
    icons: [ReactIcon],
    deployedLink: "https://react-formik-3qo1.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/react-formik",
    image: FormikImage,
    detail:
      "Forms are commonly used in every websites , this project is implemented using formik and yup packages for validation purpose. This packages helps to easily render the error messages if there is a validation error in name field or email field or in number field beacuse of their unique string types",
  },

  {
    id: 21,
    title: "Material-UI",
    framework: "React js",
    cardIcon: ReactIcon,
    icons: [ReactIcon, MaterialIcon],
    deployedLink: "https://react-material-ui-epis.vercel.app",
    gitLink: "https://github.com/Adithyavarun-creator/React-MaterialUI",
    image: MaterialImage,
    detail:
      "Clone of Facebook frontend part designed with Material-UI that has simplest way of coding in jsx tags instead of creating css files and declaring design styles",
  },
];
